import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import TagManager from 'react-gtm-module';

import { Logo, Img, SearchBar, SearchBtn } from "../UI/UI";
import { isMobile, getUrl } from "../../Utility/Utility";
import "./Menu.css";

const appCountrys = [
  { langCode: "de", subDomain: "de", countryName: "Deutsch" },
  { langCode: "nl", subDomain: "nl", countryName: "Dutch" },
  { langCode: "at", subDomain: "at", countryName: "Österreich" },
  { langCode: "pl", subDomain: "pl", countryName: "Polski" },
  { langCode: "ro", subDomain: "ro", countryName: "Română" },
  { langCode: "se", subDomain: "se", countryName: "Svenska" },
  { langCode: "ch", subDomain: "ch", countryName: "Schwyzerdütsch" },
  { langCode: "cz", subDomain: "cz", countryName: "Cseh" },
  { langCode: "dk", subDomain: "dk", countryName: "Danish" },
  { langCode: "hu", subDomain: "hu", countryName: "Magyar" },
  { langCode: "gb", subDomain: "uk", countryName: "English" },
  { langCode: "ru", subDomain: "ru", countryName: "Русский" },
  { langCode: "fr", subDomain: "fr", countryName: "Français" },
  { langCode: "es", subDomain: "es", countryName: "Español" },
  { langCode: "it", subDomain: "it", countryName: "Italiana" },
  { langCode: "eu", subDomain: "eu", countryName: "الإمارات العربية المتحدة" },
  {
    langCode: "eu-en",
    subDomain: "eu-en",
    countryName: "United Arab Emirates",
  },
];

const CurrentFlagIcon = (props) => {
  var lang = props.lang ? props.lang : "";
  var langName = props.langName ? props.langName : "";
  var hideArrow = props.hideArrow === true ? true : false;
  var arrowDown = props.arrowDown === false ? true : false;
  let arrow = null;

  if (hideArrow == false) {
    arrow = (
      <Img
        desktopImg={"/right-arrow-wb.png"}
        cssClass={`bottom-arrow ${
          arrowDown === true ? "ac-arrow-down" : "ac-arrow-up"
        }`}
      />
    );
  }
  if (isMobile()) {
    return (
      <div className="flat-icon-div">
        <div className={"flat-icon-wrapper flat-icon-" + lang}>
          <button onClick={props.setLangState}>
            <Img
              desktopImg={"/flags/4x3/" + lang + ".svg"}
              cssClass={"ac-flag"}
            />
            <div>
              <p>{langName}</p>
            </div>
            {arrow}
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className={"flat-icon-wrapper flat-icon-" + lang}>
        <button onClick={props.setLangState}>
          <Img desktopImg={"/flags/4x3/" + lang + ".svg"} />
          <div>
            <p>{langName}</p>
          </div>
          {arrow}
        </button>
      </div>
    );
  }
};

class Menu extends Component {
  state = {
    isOpen: false,
    isLangOpen: false,
    isArrowDown: false,
    isHover: false,
    keyWord: "",
    isSearchBarOpen: false,
    isPopupOpen: "",
  };

  getSearchValue = (e) => {
    this.setState({
      keyWord: e.target.value,
    });
  };

  onkeyUp = (e) => {
    if (this.state.keyWord == "") {
    } else {
      if (e.key === "Enter") {
        window.location.href =
          getUrl() + "Pages/SearchPage/?q=" + e.target.value;
      }
      // this.setState({ isPopupOpen:'ac-open' });
    }
  };
  onBlur = (e) => {
    if (isMobile()) {
      window.location.href = getUrl() + "Pages/SearchPage/?q=" + e.target.value;
    } else {
      null;
    }
  };

  showSearchResults = () => {
    if (this.state.keyWord == "") {
      alert("Please, type a search word.");
    } else {
      window.location.href =
        getUrl() + "Pages/SearchPage/?q=" + this.state.keyWord;
    }
  };

  showSearchBar = () => {
    if (this.state.isSearchBarOpen == false) {
      this.setState({ isSearchBarOpen: true });
    } else {
      this.setState({ isSearchBarOpen: false });
    }

    if (isMobile()) {
      this.setMenuState();
    }
  };

  setMenuState = () => {
    if (this.state.isLangOpen) {
      this.setState({
        isLangOpen: !this.state.isLangOpen,
        isOpen: !this.state.isOpen,
      });
    } else {
      this.setState({
        isOpen: !this.state.isOpen,
      });
    }
  };
  redirect = (subDomain) => {
    if (
      subDomain === "de" ||
      subDomain === "at" ||
      subDomain === "ch" ||
      subDomain === "en" ||
      subDomain === "pl" ||
      subDomain === "it" ||
      subDomain === "es" ||
      subDomain === "ru" ||
      subDomain === "fr" ||
      subDomain === "eu" ||
      subDomain === "eu-en"
    ) {
      window.location.href = "https://new.goisrael.com/" + subDomain;
    } else {
      window.location.href = "https://goisrael.com/?lang=" + subDomain;
      // window.location.href =  'https://localhost:3000/international/?lang=' + subDomain;
    }
  };

  setLangState = () => {
    if (isMobile()) {
      this.setState({
        isLangOpen: !this.state.isLangOpen,
        isArrowDown: !this.state.isArrowDown,
        // isOpen : !this.state.isOpen
      });
    } else {
      this.setState({
        isLangOpen: !this.state.isLangOpen,
        isArrowDown: !this.state.isArrowDown,
      });
    }
  };

  render() {
    const isLangOpen = this.state.isLangOpen;
    let cssClass = "inner";
    let parentCssClass = "";
    let navOpen = "";

    if (this.state.isOpen === true) {
      cssClass += " open";
      navOpen += " open";
    }

    var countryContainer = null;
    var countryCssClass = "country-close";

    if (isLangOpen) {
      countryCssClass = "country-open";

      countryContainer = appCountrys.map((o) => {
        return (
          <CurrentFlagIcon
            lang={o.langCode}
            langName={o.countryName}
            setLangState={() => {
              this.redirect(o.subDomain);
            }}
            hideArrow={true}
          />
        );
      });
    }

    var langName = "UK";
    var langCode = "gb";
    var CurrentLang = localStorage.getItem("currentLang");

    if (CurrentLang != null) {
      langName = CurrentLang.toUpperCase();
      if (CurrentLang == "uk") {
        langCode = "gb";
        langName = "English";
      } else {
        langCode = CurrentLang;
      }
    }

    // alert(langName);

    return (
      <header>
        {(this.state.isLangOpen || this.state.isOpen) && (
          <div
            className="nav-trigger-overlay"
            onClick={this.setLangState}
          ></div>
        )}
        <div className="menu-outer-wrapper">
          <div className="container-flued">
            {!isMobile() ? (
              <div className="container">
                <div className="col-50 ac-social-wrappper">
                  {/* <a
                    href="https://www.facebook.com/goisrael"
                    aria-label="facebook"
                    className="ac-facebook-link ac-icon-twitter"
                  >
                    <span className="ac-screen-reader-only">facebook</span>
                  </a>
                  <a
                    href="https://twitter.com/israeltourism"
                    aria-label="twitter"
                    className="ac-twitter-link"
                  >
                    <span className="ac-screen-reader-only">twitter</span>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UClnfG0wryFSVWcmkQ_VCFTw"
                    aria-label="youtube"
                    className="ac-youtube-link"
                  >
                    <span className="ac-screen-reader-only">youtube</span>
                  </a>
                  <a
                    href="https://www.flickr.com/photos/israelphotogallery/sets/"
                    aria-label="flickr"
                    className="ac-flickr-link"
                  >
                    <span className="ac-screen-reader-only">flickr</span>
                  </a>
                  <a
                    href="https://www.instagram.com/visit_israel/"
                    aria-label="instagram"
                    className="ac-instagram-link"
                  >
                    <span className="ac-screen-reader-only">instagram</span>
                  </a> */}
                </div>
                <div className="col-50 ac-search-box-wrapper">
                  <SearchBtn
                    cssClass={"ac-search-btn"}
                    click={this.showSearchBar}
                  />
                  {!isMobile() ? (
                    <CurrentFlagIcon
                      lang={langCode}
                      langName={langName}
                      setLangState={this.setLangState}
                      hideArrow={false}
                    />
                  ) : null}
                </div>
              </div>
            ) : null}
            {this.state.isSearchBarOpen ? (
              <SearchBar
                cssClass={"ac-search-bar"}
                cssClasswrapper={"ac-wrapper-search-bar"}
                keyUp={this.onkeyUp}
                Change={this.getSearchValue}
                keyWord={this.state.keyWord}
                click={this.showSearchBar}
                cssClassPopupOpen={this.isPopupOpen}
                clickForResults={this.showSearchResults}
                blurOut={this.onBlur}
              />
            ) : null}
          </div>
          {isMobile() ? (
            <div className={"ac-box-shadow" + cssClass}></div>
          ) : null}
          <div className="container container2">
            <div className="col col-15 logo-outer-wrapper">
              <NavLink exact className="first" to="/">
                <span className="ac-screen-reader-only">logo</span>
                <Logo />
              </NavLink>
            </div>
            <div className="col col-85 menu-inner-wrapper">
              <div className={cssClass}>
                {isMobile() ? (
                  <SearchBar
                    cssClass={"ac-search-bar"}
                    cssClasswrapper={"ac-wrapper-search-bar"}
                    keyUp={this.onkeyUp}
                    Change={this.getSearchValue}
                    keyWord={this.state.keyWord}
                    click={this.showSearchBar}
                    cssClassPopupOpen={this.isPopupOpen}
                    clickForResults={this.showSearchResults}
                    blurOut={this.onBlur}
                  />
                ) : null}

                <NavLink exact className="ac_menuitemsOTHER first" to="/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Home', 'event_details':'-',}})}>
                  Home
                </NavLink>
                {/*<NavLink  exact to="/Pages/bestDeals">Best Deals</NavLink>*/}
                <NavLink
                  className="ac_menuitemsOTHER"
                  exact
                  to={"/#chose-interest"}
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'INTERESTS', 'event_details':'-',}})}
                >
                  INTERESTS
                </NavLink>
                <NavLink
                  className="ac_menuitemsOTHER"
                  exact
                  to={`/#travel-planning`}
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'TRAVEL PLANNING', 'event_details':'-',}})}

                >
                  TRAVEL PLANNING
                </NavLink>

                <NavLink
                  className="ac_menuitemsOTHER"
                  exact
                  to="/Pages/Gallery/"
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'GALLERY', 'event_details':'-',}})}

                >
                  GALLERY
                </NavLink>
                {/* <NavLink exact to="/Pages/FAQ">
                  FAQ
                </NavLink> */}
                {isMobile() ? (
                  <CurrentFlagIcon
                    lang={langCode}
                    langName={langName}
                    setLangState={this.setLangState}
                    hideArrow={false}
                    arrowDown={this.state.isArrowDown}
                  />
                ) : null}
                {isMobile() ? (
                  <div
                    className={"container country-container " + countryCssClass}
                  >
                    <div className="country-container-inner">
                      <div className="country-container-title">
                        <h3>Choose your language:</h3>
                        <button
                          id="close-lang"
                          type="button"
                          onClick={this.setLangState}
                        >
                          <svg
                            aria-hidden="true"
                            focusable="true"
                            data-prefix="fas"
                            data-icon="times"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 352 512"
                            class="svg-inline--fa fa-times fa-w-11 fa-2x"
                          >
                            <path
                              fill="currentColor"
                              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                              class=""
                            ></path>
                          </svg>
                        </button>
                      </div>
                      <div className="country-container-flags-wrapper">
                        {countryContainer}
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* {isMobile() ? (
                  <div className="ac-social-mobile">
                    <a
                      href="https://www.facebook.com/goisrael"
                      aria-label="facebook"
                      className="ac-facebook-link ac-icon-twitter"
                    >
                      <span className="ac-screen-reader-only">facebook</span>
                    </a>
                    <a
                      href="https://twitter.com/israeltourism"
                      aria-label="twitter"
                      className="ac-twitter-link"
                    >
                      <span className="ac-screen-reader-only">twitter</span>
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UClnfG0wryFSVWcmkQ_VCFTw"
                      aria-label="youtube"
                      className="ac-youtube-link"
                    >
                      <span className="ac-screen-reader-only">youtube</span>
                    </a>
                    <a
                      href="https://www.flickr.com/photos/israelphotogallery/sets/"
                      aria-label="flickr"
                      className="ac-flickr-link"
                    >
                      <span className="ac-screen-reader-only">flickr</span>
                    </a>
                    <a
                      href="https://www.instagram.com/visit_israel/"
                      aria-label="instagram"
                      className="ac-instagram-link"
                    >
                      <span className="ac-screen-reader-only">instagram</span>
                    </a>
                  </div>
                ) : null} */}
              </div>
              <div className="show-on-mobile">
                {/*<button className="open-mobile-menu navbar-toggle" onClick={this.setMenuState} >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>*/}

                <button
                  className={`open-mobile-menu navbar-toggle ${navOpen}`}
                  onClick={this.setMenuState}
                  id="nav-icon1"
                  aria-label="navigator button"
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
            <div className="clear"></div>
          </div>
        </div>

        {!isMobile() ? (
          <div className={"container country-container " + countryCssClass}>
            <div className="country-container-inner">
              <div className="country-container-title">
                <h3>Choose your language:</h3>
                <button
                  id="close-lang"
                  type="button"
                  onClick={this.setLangState}
                >
                  <svg
                    aria-hidden="true"
                    focusable="true"
                    data-prefix="fas"
                    data-icon="times"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 352 512"
                    className="svg-inline--fa fa-times fa-w-11 fa-2x"
                  >
                    <path
                      fill="currentColor"
                      d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                      className=""
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="country-container-flags-wrapper">
                {countryContainer}
              </div>
            </div>
          </div>
        ) : null}
      </header>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.js